import React, {Component} from "react";
import instance from "../../axios-spc";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import classes from "./Settings.css";
import Box from "@mui/material/Box";
import {Redirect} from "react-router-dom";
import Button from "../../components/UI/Button/Button"
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import * as actions from "../../store/actions";
import {connect} from "react-redux";
import {MaterialReactTable} from "material-react-table";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Snackbar from "../../components/UI/Snackbar/Snackbar";
import Spinner from "../../components/UI/Spinner/Spinner";
import ModalDialog from "../../components/UI/Modal/ModalCampagna";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import {DateRangePicker} from "mui-daterange-picker";
import {it} from "date-fns/locale";
import InputAdornment from "@material-ui/core/InputAdornment";
import {DateRangeIcon} from "@material-ui/pickers/_shared/icons/DateRangeIcon";
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import * as XLSX from 'xlsx';
import crypto from "crypto";

class Settings extends Component {

    state = {
        brands: [],
        modelli: [],
        campagne: [],
        devices: [],
        devicesToUpload: [],
        devicesError: [],
        clienti: [],
        utenti: [],
        isGestioneDevice: false,
        isGestioneCampagne: false,
        isGestioneUtenti: false,
        idBrandSelezionato: null,
        idMemoriaSelezionato: null,
        idClienteSelezionato: null,
        idTipoDeviceSelezionato: 1,
        modello: {value: '', touched: false},
        seriale: {value: '', touched: false},
        workingPrice: {value: '', touched: false},
        prezzoCampagna: {value: '', touched: false},
        idCampagna: {value: '', touched: false},
        skuCampagna: {value: '', touched: false},
        memoria: [
            {key: 1, value: 1, label: '1 GB'},
            {key: 2, value: 2, label: '2 GB'},
            {key: 3, value: 3, label: '4 GB'},
            {key: 4, value: 4, label: '8 GB'},
            {key: 5, value: 5, label: '16 GB'},
            {key: 6, value: 6, label: '32 GB'},
            {key: 7, value: 7, label: '64 GB'},
            {key: 8, value: 8, label: '128 GB'},
            {key: 9, value: 9, label: '256 GB'},
            {key: 10, value: 10, label: '512 GB'},
            {key: 11, value: 11, label: '1 TB'},
            {key: 12, value: 12, label: '2 TB'},
            {key: 99, value: 99, label: 'Unique'},
        ],
        tipoDevice: [
            {key: 1, value: 1, label: 'SMARTPHONE'},
            {key: 2, value: 2, label: 'TABLET'},
            {key: 3, value: 3, label: 'SMARTWATCH'},
            {key: 4, value: 4, label: 'CONSOLE'},
            {key: 5, value: 5, label: 'PC'}
        ],
        isLettoreCd: [
            {key: 0, value: 0, label: 'NO'},
            {key: 1, value: 1, label: 'SI'}
        ],
        inserimentoOk: false,
        inserimentoKo: false,
        okMessage: null,
        koMessage: null,
        loading: false,
        isInserimentoCampagna: false,
        idModelNameCampagnaIn: null,
        modelNameCampagnaIn: null,
        idBrandCampagnaOut: null,
        brandCampagnaOut: null,
        imeiChecked: true,
        skuChecked: false,
        eanChecked: false,
        openDate: false,
        dateRange: null,
        startDate: null,
        endDate: null,
        isDuplicazioneCampagna: false,
        campagnaDaDuplicare: null,
        isCaricamentoExcel: false,
        uploadLoading: false,
        isModificaUtente: false,
        utenteDaModificare: null,
        pswUtente: {value: '', touched: false},
        isPc: false
    };

    componentDidMount() {
        this.getBrands();
        this.getDevices();
        this.getClienti();
        this.getUsers();
    }

    getClienti() {
        instance.post('/getNegozi').then(resp => {
            let result = resp.data.map( el => ({key: el.id_affiliato, value: el.id_affiliato, label: el.ragione_sociale}) );
            this.setState({clienti: result})
        });
    }

    getUsers() {
        let postData = {
            id_operatore: null,
            is_active: 1,
            is_dummy: 0
        };
        instance.post('/getUser', postData).then(resp => {
            for (let i in resp.data) {
                let resetPsw = (<SettingsBackupRestoreIcon titleAccess={"RESET PSW"} onClick={() => this.openModalResetPsw(resp.data[i])} style={{width: '27px', cursor: 'pointer', padding: '2px', color: '#235884', fontSize: 'xx-large',  marginRight: '5px'}}/>);
                resp.data[i].resetPsw = resetPsw;
            }
            this.setState({utenti: resp.data})
        });
    }

    getBrands = () => {
        var postData = {
            id_model_name: null,
            id_brand: null,
            id_memory: null
        };
        instance.post('/getPriceCheckBrands', postData).then(resp => {
            console.log(resp);
            let result = resp.data.map( el => ({key: el.id_brand, value: el.id_brand, label: el.brand_name}) );
            result.unshift({key: 0, value: 0, label: "ALL"});
            this.setState({brands: result})
        });
    };

    getDevices = () => {
        this.setState({loading: true})
        var postData = {
            id_negozio: localStorage.getItem("idNegozio"),
        };
        instance.post('/getPriceCheckPrice', postData).then(resp => {
            console.log(resp);
            for (let i in resp.data) {
                resp.data[i].key = i;
            }
            this.setState({devices: resp.data, loading: false})
        });
    };

    getCampagne = (payloadFiltri) => {
        let postData = {
            id_negozio: payloadFiltri === -1 ? 0 : payloadFiltri,
        };
        instance.post('/getCampagne', postData).then(resp => {
            for (let i in resp.data) {
                resp.data[i].validita = new Date(resp.data[i].data_inizio).toLocaleDateString() + " - " + new Date(resp.data[i].data_fine).toLocaleDateString();
                resp.data[i].dati_raccolti = '';
                if (resp.data[i].imei === 1) (resp.data[i].dati_raccolti = resp.data[i].dati_raccolti + ' IMEI, ');
                if (resp.data[i].serial === 1) (resp.data[i].dati_raccolti = resp.data[i].dati_raccolti + ' SERIALE,');
                if (resp.data[i].ean === 1) (resp.data[i].dati_raccolti = resp.data[i].dati_raccolti + ' EAN ');
                let duplica = (<AddCircleIcon titleAccess={"DUPLICA SU CLIENTE"} onClick={() => this.openModalDuplicazione(resp.data[i])} style={{width: '27px', cursor: 'pointer', padding: '2px', color: '#235884', fontSize: 'xx-large',  marginRight: '5px'}}/>);
                resp.data[i].duplica = duplica;
            }
            this.setState({campagne: resp.data})
        });
    };

    getModels = (idBrand) => {
        if (idBrand === 0) {
            let allModelli = [{key: 0, value: 0, label: 'ALL'}]
            this.setState({modelli: allModelli})
        } else {
            var postData = {
                id_negozio: localStorage.getItem("idNegozio"),
                id_brand: idBrand
            };
            instance.post('/getPriceCheckModels', postData).then(resp => {
                let result = resp.data.map(el => ({
                    key: el.id_model_name,
                    value: el.id_model_name,
                    label: el.model_name
                }))
                this.setState({modelli: result})
            });
        }
    };

    openModalDuplicazione = (campagna) => {
        console.log(campagna);
        this.setState({isDuplicazioneCampagna: true, campagnaDaDuplicare: campagna})
    };

    openModalResetPsw = (utente) => {
        console.log(utente);
        this.setState({isModificaUtente: true, utenteDaModificare: utente})
    };
    setCampagnaCliente = () => {
        let postData = {
            sku: this.state.campagnaDaDuplicare.sku,
            id_affiliato: this.state.idClienteSelezionato
        };

        instance.post('/setCampagnaSupervalutazione', postData).then(resp => {
            console.log(resp.data);
            if (resp.data[0].ret_code === 0) {
                this.setState({inserimentoOk: true, okMessage: 'Campagna associata con successo al nuovo cliente!', isDuplicazioneCampagna: false, campagnaDaDuplicare: null});
                this.filtraCampagne();
            } else {
                this.setState({inserimentoKo: true, koMessage: 'Errore nella modifica della campagna'})
            }
        }).catch(error => {
            this.setState({inserimentoKo: true, koMessage: 'Errore nella modifica della campagna'})
        });
    };

    setNuovaPsw = (utente) => {
        let postData = {
            id_operatore: utente.id_operatore,
            user_psw: crypto.createHash('md5').update(this.state.pswUtente.value).digest('hex'),
            is_blocked: 0,
            is_active: 1
        };

        instance.post('/setUser', postData).then(resp => {
            let updatedForm = {
                ...this.state.pswUtente
            };
            updatedForm.value = '';
            updatedForm.touched = false;
            if (resp.data[0].ret_code === 0 || resp.data[0].ret_code > 2) {
                this.setState({inserimentoOk: true, okMessage: 'Psw aggiornata con successo', isModificaUtente: false, utenteDaModificare: null, pswUtente: updatedForm});
            } else {
                this.setState({inserimentoKo: true, koMessage: 'Errore nella modifica della password'})
            }
        }).catch(error => {
            this.setState({inserimentoKo: true, koMessage: 'Errore nella modifica della password'})
        });
    };

    aggiornaUltimoPswChange = (utente) => {
        let postData = {
            id_operatore: utente.id_operatore,
            is_blocked: 0,
            is_active: 1
        };

        instance.post('/setUser', postData).then(resp => {
            console.log(resp.data);
            if (resp.data[0].ret_code === 0 || resp.data[0].ret_code > 2) {
                this.setState({inserimentoOk: true, okMessage: 'Utenza riattivata', isModificaUtente: false, utenteDaModificare: null});
            } else {
                this.setState({inserimentoKo: true, koMessage: 'Errore nella riattivazione'})
            }
        }).catch(error => {
            this.setState({inserimentoKo: true, koMessage: 'Errore nella riattivazione'})
        });
    };

    filtraCampagne() {
        let payloadFiltri = this.state.idClienteSelezionato;
        this.getCampagne(payloadFiltri)
    }

    ricercaCancelHandler = () => {
        let updatedForm = {
            ...this.state.pswUtente
        };
        updatedForm.value = '';
        updatedForm.touched = false;
        this.setState({isInserimentoCampagna: false, isDuplicazioneCampagna: false, isCaricamentoExcel: false, isModificaUtente: false, pswUtente: updatedForm})
    };

    openModalCreazioneCampagna() {
        this.setState({isInserimentoCampagna: true})
    }

    openModalCaricaExcel() {
        this.setState({isCaricamentoExcel: true})
    }

    onBrandsChange = (event, values) => {
        if (values) this.setState({idBrandSelezionato: values.value}, this.getModels( values.key)); else this.setState({idBrandSelezionato: null, modelli: []});
    };
    onBrandsOutChange = (event, values) => {
        if (values) this.setState({idBrandCampagnaOut: values.value, brandCampagnaOut: values.label}); else this.setState({idBrandCampagnaOut: null, brandCampagnaOut: null});
    };

    onModelsChange = (event, values) => {
        if (values) this.setState({idModelNameCampagnaIn: values.value, modelNameCampagnaIn: values.label}); else this.setState({idModelNameCampagnaIn: null, modelNameCampagnaIn: null, modelli: []});
    };

    onClientiChange = (event, values) => {
        if (values) this.setState({idClienteSelezionato: values.value}); else this.setState({idClienteSelezionato: null});
    };
    onLettoreCdChange = (event, values) => {
        if (values) this.setState({isLettoreCd: values.value});
    };
    onMemoryChange = (event, values) => {
        if (values) this.setState({idMemoriaSelezionato: values.value})
    };
    onTipoDeviceChange = (event, values) => {
        if (values) this.setState({idTipoDeviceSelezionato: values.value, isPc: values.value == 4})
    };
    openOperazioniDevice = () => {
        this.getBrands();
        this.setState({isGestioneDevice: true, isGestioneCampagne: false, isGestioneUtenti: false})
    };
    openOperazioniCampagna = () => {
        this.setState({isGestioneDevice: false, isGestioneCampagne: true, isGestioneUtenti: false})
    };
    openOperazioniUtenti = () => {
        this.setState({isGestioneDevice: false, isGestioneCampagne: false, isGestioneUtenti: true})
    };

    handleChangeImei = (event) => {
        this.setState({imeiChecked: event.target.checked})
    };
    handleChangeSku = (event) => {
        this.setState({skuChecked: event.target.checked})
    };
    handleChangeEan = (event) => {
        this.setState({eanChecked: event.target.checked})
    };

    toggleDateRange() {
        let openDate = !this.state.openDate;
        this.setState({openDate: openDate})
    }

    setDateRange(dateRange) {
        let dateStart = dateRange.startDate.toLocaleString("it-IT", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        }) ;
        let dateEnd = dateRange.endDate.toLocaleString("it-IT", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });

        let startDateFilter = dateRange.startDate;
        startDateFilter.setHours(startDateFilter.getHours() + startDateFilter.getTimezoneOffset()/-60);
        let endDateFilter = dateRange.endDate;
        endDateFilter.setHours(endDateFilter.getHours() + endDateFilter.getTimezoneOffset()/-60);
        this.setState({dateRange: dateStart + " - " + dateEnd, openDate: false, startDate: startDateFilter.toJSON().slice(0, 10), endDate: endDateFilter.toJSON().slice(0, 10)})
    }

    inserisciDevice = () => {

        let postData = {
            id_brand: this.state.idBrandSelezionato,
            model_name: this.state.modello.value,
            id_memory: this.state.idMemoriaSelezionato,
            working_price: this.state.workingPrice.value.replace(",","."),
            id_device_type: this.state.idTipoDeviceSelezionato,
            model_code: this.state.seriale.value,
            lettore_cd: this.state.isLettoreCd.value
        };

        instance.post('/setPriceCheckDevice', postData).then(resp => {
            console.log(resp.data);
            if (resp.data[0].ret_code == 0) {
                const updatedFormPrice = {
                    ...this.state.workingPrice
                };
                updatedFormPrice.value = '';
                updatedFormPrice.touched = false;
                const updatedFormModel = {
                    ...this.state.modello
                };
                updatedFormModel.value = '';
                updatedFormModel.touched = false;

                this.setState({inserimentoOk: true, okMessage: resp.data[0].ret_messagge});
                this.getDevices();
            } else {
                this.setState({inserimentoKo: true, koMessage: resp.data[0].ret_messagge})
            }
        });
        console.log(postData);

    };

    inputonChangeHandler = (event, id) => {
        switch (id) {
            case "modello": {
                const updatedForm = {
                    ...this.state.modello
                };
                updatedForm.value = event.target.value;
                updatedForm.touched = true;
                this.setState({modello: updatedForm});
                break;
            }
            case "seriale": {
                const updatedForm = {
                    ...this.state.seriale
                };
                updatedForm.value = event.target.value;
                updatedForm.touched = true;
                this.setState({seriale: updatedForm});
                break;
            }
            case "workingPrice": {
                const updatedForm = {
                    ...this.state.workingPrice
                };
                updatedForm.value = event.target.value;
                updatedForm.touched = true;
                this.setState({workingPrice: updatedForm});
                break;
            }
            case "prezzoCampagna": {
                const updatedForm = {
                    ...this.state.prezzoCampagna
                };
                updatedForm.value = event.target.value;
                updatedForm.touched = true;
                this.setState({prezzoCampagna: updatedForm});
                break;
            }
            case "idCampagna": {
                const updatedForm = {
                    ...this.state.idCampagna
                };
                updatedForm.value = event.target.value;
                updatedForm.touched = true;
                this.setState({idCampagna: updatedForm});
                break;
            }
            case "skuCampagna": {
                const updatedForm = {
                    ...this.state.skuCampagna
                };
                updatedForm.value = event.target.value;
                updatedForm.touched = true;
                this.setState({skuCampagna: updatedForm});
                break;
            }
            case "pswUtente": {
                const updatedForm = {
                    ...this.state.pswUtente
                };
                updatedForm.value = event.target.value;
                updatedForm.touched = true;
                this.setState({pswUtente: updatedForm});
                break;
            }
            default: {
                const oldState = {
                    ...this.state
                };
                this.setState({state: oldState});
                break;
            }
        }

    };

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return ;
        }
        this.setState({inserimentoOk: false, inserimentoKo: false})
    };

    handleFileUpload = (e) => {
        let errorDevices = [];

        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = (evt) => {
            const data = new Uint8Array(evt.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const worksheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[worksheetName];
            const jsonData = XLSX.utils.sheet_to_json(worksheet);

            this.setState({devicesToUpload: jsonData, uploadLoading: true});
            console.log(jsonData);
            let postData = {
                data: jsonData
            };
            instance.post('/massiveUpload', postData).then(resp => {
                console.log(resp.data);
                if (resp.data.ret_code === 0) {
                    this.setState({uploadLoading: false, inserimentoOk: true, okMessage: 'File excel importato con successo!', devicesError: []});
                    this.getDevices();
                } else {
                    let errorJson = JSON.parse(resp.data.ret_message);
                    console.log(errorJson);
                    this.setState({uploadLoading: false, inserimentoKo: true, koMessage: 'Errore su alcuni device', devicesError: errorJson});
                    this.getDevices();
                }
            }).catch(err => {
                console.log(err);
                this.setState({uploadLoading: false, inserimentoKo: true, koMessage: 'Errore generale', devicesError: []})
                this.getDevices();
            });
        };
        reader.readAsArrayBuffer(file);
    };

    handleSaveRow = async ({ exitEditingMode, row, values }) => {
        console.log(values);
        console.log(row);
        //if using flat data and simple accessorKeys/ids, you can just do a simple assignment here.
        this.state.devices[row.index] = values;
        //send/receive api updates here
        let postData = {
            id_model_name: row.original.id_model_name,
            id_brand: row.original.id_brand,
            model_name: values.model_name,
            id_memory: row.original.id_memory,
            working_price: values.working_price.replace(",","."),
            id_device_type: row.original.id_device_type
        };

        instance.post('/setPriceCheckDevice', postData).then(resp => {
            console.log(resp.data);
            if (resp.data[0].ret_code == 0) {
                this.setState({inserimentoOk: true, okMessage: resp.data[0].ret_messagge, idBrandSelezionato: null, idMemoriaSelezionato: null, idTipoDeviceSelezionato: 1, isGestioneDevice: true})
                this.getDevices();
            } else {
                this.setState({inserimentoKo: true, koMessage: resp.data[0].ret_messagge})
            }
        });
        exitEditingMode(); //required to exit editing mode
    };

    handleSaveRowCampagne = async ({ exitEditingMode, row, values }) => {
        console.log(values);
        console.log(row);
        //if using flat data and simple accessorKeys/ids, you can just do a simple assignment here.
        this.state.campagne[row.index] = values;
        let startDate = values.validita.substring(0,10);
        let endDate = values.validita.substring(values.validita.length - 10, values.validita.length);

        let startDateToFormat = startDate.substring(6,10) + "-" + startDate.substring(3,5) + "-" + startDate.substring(0,2) + " 00:00";
        let endDateToFormat = endDate.substring(6,10) + "-" + endDate.substring(3,5) + "-" + endDate.substring(0,2) + " 00:00";

        //send/receive api updates here
        let postData = {
            sku: row.original.sku,
            supervalutazione: values.supervalutazione,
            data_inizio: startDateToFormat,
            data_fine: endDateToFormat
        };

        instance.post('/setCampagnaSupervalutazione', postData).then(resp => {
            console.log(resp.data);
            if (resp.data[0].ret_code === 0) {
                this.setState({inserimentoOk: true, okMessage: 'Campagna modificata con successo!'});
                this.filtraCampagne();
            } else {
                this.setState({inserimentoKo: true, koMessage: 'Errore nella modifica della campagna'})
            }
        }).catch(error => {
            this.setState({inserimentoKo: true, koMessage: 'Errore nella modifica della campagna'})
        });
        exitEditingMode(); //required to exit editing mode
    };

    inserisciCampagna = () => {
        let postData = {
            id_campagna: this.state.idCampagna.value,
            sku: this.state.skuCampagna.value,
            id_model_name: this.state.idModelNameCampagnaIn,
            model_name_campagna: this.state.idCampagna.value.replaceAll("Promo ", '').replaceAll("supervalutazione", ''),
            id_brand_campagna: this.state.idBrandCampagnaOut,
            supervalutazione: this.state.prezzoCampagna.value,
            imei: this.state.imeiChecked ? 1 : 0,
            serial: this.state.skuChecked ? 1 : 0,
            ean: this.state.eanChecked ? 1 : 0,
            data_inizio: this.state.startDate === null ? null : this.state.startDate + ' 00:00',
            data_fine: this.state.endDate == null ? null : this.state.endDate + ' 23:59',
            id_affiliato: this.state.idClienteSelezionato
        };
        console.log(postData)
        instance.post('/setCampagnaSupervalutazione', postData).then(resp => {
            console.log(resp.data);
            if (resp.data[0].ret_code === 0) {
                this.setState({inserimentoOk: true, okMessage: 'Campagna inserita con successo!', isInserimentoCampagna: false });
                this.azzeraDatiCampagne();
                this.filtraCampagne();
            } else {
                this.setState({inserimentoKo: true, koMessage: 'Errore nella creazione della campagna'})
            }
        }).catch(error => {
            this.setState({inserimentoKo: true, koMessage: 'Errore nella creazione della campagna'})
        });
    };

    scaricaExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(this.state.devices);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Devices");
        XLSX.writeFile(workbook, 'Devices.xlsx');
    };
    scaricaExcelError = () => {
        const worksheet = XLSX.utils.json_to_sheet(this.state.devicesError);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Error");
        XLSX.writeFile(workbook, 'Device_errati.xlsx');
    };

    azzeraDatiCampagne = () => {

        const updatedFormPrezzo = {
            ...this.state.prezzoCampagna
        };
        updatedFormPrezzo.value = null;
        updatedFormPrezzo.touched = true;
        const updatedFormSku = {
            ...this.state.skuCampagna
        };
        updatedFormSku.value = null;
        updatedFormSku.touched = true;
        const updatedFormId = {
            ...this.state.idCampagna
        };
        updatedFormId.value = null;
        updatedFormId.touched = true;

        this.setState({
            idModelNameCampagnaIn: null,
            modelNameCampagnaIn: null,
            idBrandCampagnaOut: null,
            brandCampagnaOut: null,
            imeiChecked: true,
            skuChecked: false,
            eanChecked: false,
            openDate: false,
            dateRange: null,
            startDate: null,
            endDate: null,
            prezzoCampagna: updatedFormPrezzo,
            skuCampagna: updatedFormSku,
            idCampagna: updatedFormId
        })
    };

    inputChangedHandler = (event, inputIdentifier) => {

        const updatedForm = {
            ...this.state.filtriControls
        };
        const updatedFormElement = {
            ...updatedForm[inputIdentifier]
        };
        updatedFormElement.value = event.target.value;
        updatedForm[inputIdentifier] = updatedFormElement;
        this.setState({filtriControls: updatedForm})
    };

    render() {

        let authRedirect = null;
        console.log('[Settings] isAuth? ' + this.props.isAuth);
        if (!this.props.isAuth) {
            authRedirect = <Redirect to="/login"/>
        }

        let spinner = null;
        if (this.state.loading) {
            spinner = <Spinner />
        }
        let uploadSpinner = null;
        if (this.state.uploadLoading) {
            uploadSpinner = <Spinner />
        }

        let okSnack = (
            <Snackbar open={this.state.inserimentoOk} autoHideDuration={2000} closed={this.handleClose} severity="success">{this.state.okMessage}</Snackbar>
        );
        let koSnack = (
            <Snackbar open={this.state.inserimentoKo} autoHideDuration={2000} closed={this.handleClose} severity="error">{this.state.koMessage}</Snackbar>
        );

        const formElementArray = [];
        for (let key in this.state.filtriControls) {
            formElementArray.push({
                id: key,
                config: this.state.filtriControls[key]
            })
        }

        let formFiltri = (
            <Autocomplete
                id="brand"
                sx={{backgroundColor: '#f4f4f4', width: '300px', margin: 5, borderRadius: '4px',
                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                        {
                            borderColor: "#768828",
                        }
                }}
                options={this.state.clienti}
                autoHighlight
                size="small"
                variant="outlined"
                onChange={this.onClientiChange}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        InputLabelProps={{
                            style: { color: 'rgba(0, 0, 0, 0.54)' },
                        }}
                        label="Seleziona Cliente"
                        slotProps={{
                            htmlInput: {
                                ...params.inputProps,
                                autoComplete: 'new-password', // disable autocomplete and autofill
                            },
                        }}
                    />
                )}
            />
        );

        let boxOperazioni = (
            <Box style={{textAlign: '-webkit-center', display: 'inline-block', width: '30%', verticalAlign: 'top'}}>
                <Box className={classes.ResultBox}>
                    <h3 className={classes.FiltriTitle}>Operazioni </h3>
                    <Button style={{margin: '10px', borderRadius: '15px'}} clicked={() => this.openOperazioniDevice()}>{('GESTIONE DISPOSITIVI')}</Button>
                    <Button style={{margin: '10px', borderRadius: '15px'}} clicked={() => this.openOperazioniCampagna()}>{('GESTIONE CAMPAGNE')}</Button>
                    <Button style={{margin: '10px', borderRadius: '15px'}} clicked={() => this.openOperazioniUtenti()}>{('GESTIONE UTENTI')}</Button>
                </Box>
            </Box>
        );

        let formTipoDevice = (
            <Autocomplete
                id="brand"
                sx={{backgroundColor: '#f4f4f4', margin: 5, borderRadius: '4px',
                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                        {
                            borderColor: "#768828",
                        }
                }}
                options={this.state.tipoDevice}
                autoHighlight
                size="small"
                variant="outlined"
                onChange={this.onTipoDeviceChange}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        InputLabelProps={{
                            style: { color: 'rgba(0, 0, 0, 0.54)' },
                        }}
                        label="Seleziona Tipologia Dispositivo"
                        slotProps={{
                            htmlInput: {
                                ...params.inputProps,
                                autoComplete: 'new-password', // disable autocomplete and autofill
                            },
                        }}
                    />
                )}
            />
        );

        let formBrand = (
            <Autocomplete
                id="brand"
                sx={{backgroundColor: '#f4f4f4', width: '300px', margin: 0, borderRadius: '4px', display: 'inline-block',
                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                        {
                            borderColor: "#768828",
                        }
                }}
                options={this.state.brands}
                autoHighlight
                size="small"
                variant="outlined"
                onChange={this.onBrandsChange}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        InputLabelProps={{
                            style: { color: 'rgba(0, 0, 0, 0.54)' },
                        }}
                        label="Seleziona Brand Dispositivo"
                        slotProps={{
                            htmlInput: {
                                ...params.inputProps,
                                autoComplete: 'new-password', // disable autocomplete and autofill
                            },
                        }}
                    />
                )}
            />
        );
        let formLettoreCd = (
            <Autocomplete
                id="brand"
                sx={{backgroundColor: '#f4f4f4', width: '300px', margin: 0, borderRadius: '4px',
                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                        {
                            borderColor: "#768828",
                        }
                }}
                options={this.state.isLettoreCd}
                autoHighlight
                size="small"
                variant="outlined"
                onChange={this.onLettoreCdChange}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        InputLabelProps={{
                            style: { color: 'rgba(0, 0, 0, 0.54)' },
                        }}
                        label="Lettore CD"
                        slotProps={{
                            htmlInput: {
                                ...params.inputProps,
                                autoComplete: 'new-password', // disable autocomplete and autofill
                            },
                        }}
                    />
                )}
            />
        );
        let formBrandCampagnaOut = (
            <Autocomplete
                id="brand"
                sx={{backgroundColor: '#f4f4f4', width: '300px', margin: 5, borderRadius: '4px',
                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                        {
                            borderColor: "#768828",
                        }
                }}
                options={this.state.brands}
                autoHighlight
                size="small"
                variant="outlined"
                onChange={this.onBrandsOutChange}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        InputLabelProps={{
                            style: { color: 'rgba(0, 0, 0, 0.54)' },
                        }}
                        label="Seleziona Brand Dispositivo"
                        slotProps={{
                            htmlInput: {
                                ...params.inputProps,
                                autoComplete: 'new-password', // disable autocomplete and autofill
                            },
                        }}
                    />
                )}
            />
        );

        let formModello = (
            <div style={{backgroundColor: '#f4f4f4', margin: 40, width: '300px', borderRadius: '4px'}} >
                <TextField
                    sx={{ "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                            {
                                borderColor: "#768828",
                            }
                    }}
                    id="modello"
                    elementType="input"
                    fullWidth
                    value={this.state.modello.value}
                    label="Modello"
                    variant="outlined"
                    // style={{ height: '40px'}}
                    onChange={(e) => this.inputonChangeHandler(e, "modello")}
                />
            </div>
        );

        let formSeriale = (
            <div style={{backgroundColor: '#f4f4f4', margin: 40, width: '300px', borderRadius: '4px'}} >
                <TextField
                    sx={{ "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                            {
                                borderColor: "#768828",
                            }
                    }}
                    id="seriale"
                    elementType="input"
                    fullWidth
                    value={this.state.seriale.value}
                    label="Seriale"
                    variant="outlined"
                    // style={{ height: '40px'}}
                    onChange={(e) => this.inputonChangeHandler(e, "seriale")}
                />
            </div>
        );

        let formPrezzo = (
            <div style={{backgroundColor: '#f4f4f4', margin: 40, width: '300px', borderRadius: '4px'}} >
                <TextField
                    sx={{ "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                            {
                                borderColor: "#768828",
                            }
                    }}
                    id="workingPrice"
                    elementType="number"
                    fullWidth
                    value={this.state.workingPrice.value}
                    label="Prezzo"
                    variant="outlined"
                    // style={{ height: '40px'}}
                    onChange={(e) => this.inputonChangeHandler(e, "workingPrice")}
                />
            </div>
        );
        let formPrezzoCampagna = (
            <div style={{backgroundColor: '#f4f4f4', margin: 0, width: '300px', borderRadius: '4px'}} >
                <TextField
                    sx={{ "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                            {
                                borderColor: "#768828",
                            }
                    }}
                    id="prezzoCampagna"
                    elementType="number"
                    fullWidth
                    value={this.state.prezzoCampagna.value}
                    label="Valore supervalutazione"
                    variant="outlined"
                    // style={{ height: '40px'}}
                    onChange={(e) => this.inputonChangeHandler(e, "prezzoCampagna")}
                />
            </div>
        );

        let formMemoria = (
            <Autocomplete
                id="memoria"
                sx={{backgroundColor: '#f4f4f4', width: '300px', margin: 0, borderRadius: '4px',
                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                        {
                            borderColor: "#768828",
                        }
                }}
                options={this.state.memoria}
                autoHighlight
                size="small"
                variant="outlined"
                onChange={this.onMemoryChange}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        InputLabelProps={{
                            style: { color: 'rgba(0, 0, 0, 0.54)' },
                        }}
                        label="Seleziona Capacità Dispositivo"
                        slotProps={{
                            htmlInput: {
                                ...params.inputProps,
                                autoComplete: 'new-password', // disable autocomplete and autofill
                            },
                        }}
                    />
                )}
            />
        );

        let formModelloCampagna = (
            <Autocomplete
                id="modello"
                sx={{backgroundColor: '#f4f4f4', width: '300px', margin: 0, borderRadius: '4px', display: 'inline-block',
                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                        {
                            borderColor: "#768828",
                        }
                }}
                options={this.state.modelli}
                autoHighlight
                size="small"
                variant="outlined"
                // value={this.state.idModelSelezionato}
                onChange={this.onModelsChange}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        InputLabelProps={{
                            style: { color: 'rgba(0, 0, 0, 0.54)' },
                        }}
                        label="Seleziona Modello Dispositivo Ingresso"
                        slotProps={{
                            htmlInput: {
                                ...params.inputProps,
                                autoComplete: 'new-password', // disable autocomplete and autofill
                            },
                        }}
                    />
                )}
            />
        );

        let imei = (
            <FormControlLabel
                value="IMEI"
                control={<Checkbox
                    className={classes.CheckBoxes}
                    checked={this.state.imeiChecked}
                    onChange={this.handleChangeImei}
                />}
                label="IMEI"
                labelPlacement="bottom"
            />
        );
        let sku = (
            <FormControlLabel
                value="SKU"
                control={<Checkbox
                    className={classes.CheckBoxes}
                    checked={this.state.skuChecked}
                    onChange={this.handleChangeSku}
                />}
                label="SKU"
                labelPlacement="bottom"
            />
        );
        let ean = (
            <FormControlLabel
                value="EAN"
                control={<Checkbox
                    className={classes.CheckBoxes}
                    checked={this.state.eanChecked}
                    onChange={this.handleChangeEan}
                />}
                label="EAN"
                labelPlacement="bottom"
            />
        );

        let testDateRange = null;
        if (this.state.openDate) {
            testDateRange = (
                <DateRangePicker
                    definedRanges={[]}
                    locale={it}
                    open={this.state.openDate}
                    toggle={() => this.toggleDateRange()}
                    onChange={(range) => this.setDateRange(range)}
                />
            )
        }

        let dateRange = (
            <Auxiliary>
                <div style={{position: 'relative', width: '300px',}}>
                    <TextField label="Seleziona date" type="input" style={{backgroundColor: '#f4f4f4', marginTop: 30, width: '300px', borderRadius: '4px'}} variant="outlined" value={this.state.dateRange != null ? this.state.dateRange : ''} onClick={() => this.toggleDateRange()} InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <DateRangeIcon />
                            </InputAdornment>
                        )
                    }}/>
                    <div style={{position: 'absolute', display: 'flex', zIndex: '2000', top: '50px', left: '-100px'}}>
                        {testDateRange}
                    </div></div>
            </Auxiliary>
        );

        let boxInserimentoDevice = null;

        let buttonEnabled = this.state.idBrandSelezionato > 0 && this.state.idTipoDeviceSelezionato > 0 && this.state.idMemoriaSelezionato > 0 && this.state.modello.value !== null && this.state.modello.value !== '' && this.state.workingPrice.value !== null && this.state.workingPrice.value !== '';

        let boxExcel = null;

        if (this.state.isGestioneDevice)
            boxExcel = (
                <Auxiliary>
                    <br/>
                    <Box style={{textAlign: '-webkit-center', display: 'inline-block', width: '30%', verticalAlign: 'top'}}>
                        <Box className={classes.ResultBox}>
                            <h3 className={classes.FiltriTitle}>Operazioni </h3>
                            <Button style={{margin: '10px', borderRadius: '15px'}} clicked={() => this.scaricaExcel()}>{('SCARICA XLS DEVICES')}</Button>
                            <Button style={{margin: '10px', borderRadius: '15px'}} clicked={() => this.openModalCaricaExcel()}>{('CARICA DEVICES')}</Button>
                        </Box>
                    </Box>
                </Auxiliary>)

        if (this.state.isGestioneDevice)
            boxInserimentoDevice = (
                <Auxiliary>
                    {boxExcel}
                    <Box style={{textAlign: '-webkit-center'}}>
                        <Box className={classes.FiltriBox}>
                            <h3 className={classes.FiltriTitle}>{('Inserisci o modifica dispositivo')}</h3>
                            {formTipoDevice}
                            {formBrand}
                            {formModello}
                            {formMemoria}
                            {formPrezzo}
                            {this.state.isPc ? formSeriale : null}
                            {this.state.isPc ? formLettoreCd : null}
                            <Button style={{margin: '10px', borderRadius: '15px'}} clicked={() => this.inserisciDevice()} disabled={!buttonEnabled}>{('INSERISCI')}</Button>
                        </Box>
                    </Box>
                </Auxiliary>
            );

        const newColumnsDevices = [
            {accessorKey: 'brand_name', header: 'Brand', editable: false, size: 100},
            {accessorKey: 'model_name', header: 'Modello', editable: false, size: 100},
            {accessorKey: 'memory', header: 'Memoria', editable: false, size: 100},
            {accessorKey: 'working_price', header: 'Valutazione', editable: false, size: 80, Cell: ({ cell }) => cell.getValue() + " €"},
        ];

        let listaDevice = null;
        if (this.state.isGestioneDevice) {
            listaDevice = (
                <div style={{width: 'fit-content'}}>
                    <MaterialReactTable
                        columns={newColumnsDevices}
                        data={this.state.devices}
                        editingMode="modal"
                        enableEditing
                        onEditingRowSave={this.handleSaveRow}
                        initialState={{ density: 'compact'}}
                    />
                </div>
            )
        }

        const newColumnsCampagne = [
            {accessorKey: 'id_campagna', header: 'Campagna', editable: false, enableEditing: false, size: 100},
            {accessorKey: 'sku', header: 'SKU', editable: false, enableEditing: false, size: 100},
            {accessorKey: 'brand_campagna', header: 'Brand', editable: false, enableEditing: false, size: 100},
            {accessorKey: 'model_name', header: 'Device ingresso', editable: false, enableEditing: false, size: 100},
            {accessorKey: 'model_name_campagna', header: 'Device supervalutazione', enableEditing: false, editable: false, size: 100},
            {accessorKey: 'supervalutazione', header: 'Valore', editable: false, size: 80, Cell: ({ cell }) => cell.getValue() + " €"},
            {accessorKey: 'dati_raccolti', header: 'Dati', editable: false, enableEditing: false},
            {accessorKey: 'validita', header: 'Validità', editable: false, size: 100},
            {accessorKey: 'is_active', header: 'Attiva', editable: false, size: 50},
            {accessorKey: 'duplica', header: 'Duplica', editable: false, size: 50},
        ];

        let boxCampagne = null;
        if (this.state.isGestioneCampagne) {
            // if (this.state.campagne.length > 0)
            boxCampagne = (
                <Box style={{textAlign: '-webkit-center'}}>
                    <Box className={classes.FiltriBox}>
                        <h3 className={classes.FiltriTitle}>{('Campagne presenti')}</h3>
                        {formFiltri}
                        <br/>
                        <Button disabled={this.state.idClienteSelezionato <= 0} style={{margin: '10px', borderRadius: '15px'}} clicked={() => this.filtraCampagne()}>{('CERCA CAMPAGNE PER CLIENTE')}</Button>
                        <Button disabled={this.state.idClienteSelezionato <= 0} style={{margin: '10px', borderRadius: '15px'}} clicked={() => this.openModalCreazioneCampagna()}>{('NUOVA CAMPAGNA PER CLIENTE SELEZIONATO')}</Button>
                        <MaterialReactTable
                            columns={newColumnsCampagne}
                            data={this.state.campagne}
                            enableColumnActions={false}
                            enableColumnFilters={true}
                            enablePagination={false}
                            enableSorting={false}
                            enableBottomToolbar={false}
                            enableTopToolbar={true}
                            enableEditing
                            getRowId={(row) => row.sku}
                            onEditingRowSave={this.handleSaveRowCampagne}
                            initialState={{ columnPinning: { right: ['azioni'] }, density: 'compact'}}
                        />
                    </Box>
                </Box>
            );
        }

        const newColumnsUtenti = [
            {accessorKey: 'id_operatore', header: 'ID', editable: false, enableEditing: false, size: 10},
            {accessorKey: 'ragione_sociale', header: 'Rag. Soc.', editable: false, enableEditing: false, size: 70},
            {accessorKey: 'user_name', header: 'User', editable: false, enableEditing: false, size: 100},
            {accessorKey: 'negozio', header: 'Negozio', editable: false, enableEditing: false, size: 100},
            {accessorKey: 'resetPsw', header: 'PSW', editable: false, size: 50},
        ];

        let boxUtenti = null;
        if (this.state.isGestioneUtenti) {
            // if (this.state.campagne.length > 0)
            boxCampagne = (
                <Box style={{textAlign: '-webkit-center'}}>
                    <Box className={classes.FiltriBox}>
                        <h3 className={classes.FiltriTitle}>{('Utenti')}</h3>
                        <MaterialReactTable
                            columns={newColumnsUtenti}
                            data={this.state.utenti}
                            enableColumnActions={false}
                            enableColumnFilters={false}
                            enablePagination={false}
                            enableSorting={false}
                            enableBottomToolbar={false}
                            enableEditing={false}
                            getRowId={(row) => row.sku}
                            initialState={{ columnPinning: { right: ['resetPsw'] }, density: 'compact'}}
                        />
                    </Box>
                </Box>
            );
        }


        let buttonDisabled = (
            this.state.idCampagna.value === '' || this.state.skuCampagna.value == '' ||
            this.state.idBrandCampagnaOut == null ||
            this.state.brandCampagnaOut == null ||
            this.state.dateRange == null ||
            this.state.prezzoCampagna.value == null
        );

        let modal = null;
        if (this.state.isInserimentoCampagna) {
            modal = (
                <ModalDialog show={this.state.isInserimentoCampagna} modalClosed={this.ricercaCancelHandler} customStyle={"Dialog"} title={"Inserimento nuova campagna"}>
                    <div style={{backgroundColor: '#f4f4f4', margin: 40, width: '300px', borderRadius: '4px'}} >
                        <TextField
                            sx={{ "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                        borderColor: "#768828",
                                    }
                            }}
                            id="idCampagna"
                            fullWidth
                            value={this.state.idCampagna.value}
                            label="Nome Campagna"
                            variant="outlined"
                            // style={{ height: '40px'}}
                            onChange={(e) => this.inputonChangeHandler(e, "idCampagna")}
                        />
                    </div>
                    <div style={{backgroundColor: '#f4f4f4', margin: 40, width: '300px', borderRadius: '4px'}} >
                        <TextField
                            sx={{ "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                        borderColor: "#768828",
                                    }
                            }}
                            id="skuCampagna"
                            fullWidth
                            value={this.state.skuCampagna.value}
                            label="SKU Campagna"
                            variant="outlined"
                            // style={{ height: '40px'}}
                            onChange={(e) => this.inputonChangeHandler(e, "skuCampagna")}
                        />
                    </div>
                    {formBrand}
                    {formModelloCampagna}
                    {formBrandCampagnaOut}
                    {formPrezzoCampagna}
                    {dateRange}
                    {imei}
                    {sku}
                    {ean}
                    <div>
                        <Button style={{margin: '2%'}} clicked={() => this.inserisciCampagna()} disabled={buttonDisabled}>Conferma</Button>
                        <Button style={{margin: '2%', backgroundColor: '#e5e5e5', color: '#235884'}} clicked={() => this.ricercaCancelHandler()}>Annulla</Button>
                    </div>
                </ModalDialog>)
        }

        let modalDuplicazione = null;
        if (this.state.isDuplicazioneCampagna) {
            modalDuplicazione = (
                <ModalDialog show={this.state.isDuplicazioneCampagna} modalClosed={this.ricercaCancelHandler} customStyle={"Dialog"} title={"Seleziona il cliente su cui attivare la campagna"}>
                    {formFiltri}
                    <Button style={{margin: '2%'}} clicked={() => this.setCampagnaCliente(this.state.campagnaDaDuplicare)}>Conferma</Button>
                    <Button style={{margin: '2%', backgroundColor: '#e5e5e5', color: '#235884'}} clicked={() => this.ricercaCancelHandler()}>Annulla</Button>
                </ModalDialog>)
        }

        let modalUtente = null;
        if (this.state.isModificaUtente) {
            modalUtente = (
                <ModalDialog show={this.state.isModificaUtente} modalClosed={this.ricercaCancelHandler} customStyle={"Dialog"} title={"Operazioni sull'utente"}>
                    <TextField
                        id="pswUtente"
                        // select
                        fullWidth
                        variant="outlined"
                        elementType="input"
                        value={this.state.pswUtente.value}
                        label="Nuova Psw"
                        style={{width: '50%', align: 'center', margin: 10 }}
                        onChange={(e) => this.inputonChangeHandler(e, "pswUtente")}
                    >
                    </TextField>
                    <Button style={{margin: '2%'}} clicked={() => this.setNuovaPsw(this.state.utenteDaModificare)}>Reset PSW</Button>
                    <br/>
                    <Button style={{margin: '2%'}} clicked={() => this.aggiornaUltimoPswChange(this.state.utenteDaModificare)}>Rinnova PSW</Button>
                    <Button style={{margin: '2%', backgroundColor: '#e5e5e5', color: '#235884'}} clicked={() => this.ricercaCancelHandler()}>Annulla</Button>
                </ModalDialog>)
        }

        let fileUpladed = null;
        if (this.state.devicesToUpload.length > 0) {
            fileUpladed = (
                <Auxiliary>
                    <span>File caricato correttamente</span>
                    <br />
                    <Button style={{margin: '2%'}} clicked={this.uploadDevicesFromExcel}>Caricare i dati?</Button>
                </Auxiliary>
            );
        }

        let errorTable = null;
        if (this.state.devicesError.length > 0) {
            console.log("errors " + JSON.stringify(this.state.devicesError))
             errorTable =  (<Button style={{margin: '10px', borderRadius: '15px'}} clicked={() => this.scaricaExcelError()}>{('SCARICA XLS CON GLI ERRORI')}</Button>);
        }

        let modalExcel = null;
        if (this.state.isCaricamentoExcel) {
            modalExcel = (
                <ModalDialog show={this.state.isCaricamentoExcel} modalClosed={this.ricercaCancelHandler} customStyle={"Dialog"} title={"Carica file excel dei devices"}>
                    <input type="file" accept=".xlsx, .xls" onChange={(e) => this.handleFileUpload(e)} />
                    <br />
                    {uploadSpinner}
                    {errorTable}
                    <Button style={{margin: '2%', backgroundColor: '#e5e5e5', color: '#235884'}} clicked={() => this.ricercaCancelHandler()}>Annulla</Button>
                </ModalDialog>)
        }


        return (
            <Auxiliary>
                <div className={classes.Settings}>
                    {authRedirect}
                    {okSnack}
                    {koSnack}
                    <h1 className={classes.Title}>IMPOSTAZIONI</h1>
                    <div style={{height: 'auto', width: '100%', textAlign: '-webkit-center'}}>
                        {boxOperazioni}
                        {boxInserimentoDevice}
                        <br />
                        {spinner}
                        {listaDevice}
                        {boxCampagne}
                        {boxUtenti}
                        {modal}
                        {modalDuplicazione}
                        {modalExcel}
                        {modalUtente}
                    </div>
                </div>
            </Auxiliary>
        );
    }

}


const mapDispatchToProps = dispatch => {
    return {
        onAuthCheckState: () => dispatch(actions.authCheckState())
    }
};


const mapStateToProps = state => {
    return {
        isAuth: state.auth.token !== null,
        authRedirectPath: "/settings"
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(Settings)
